module.exports = __webpack_public_path__ + "static/media/bg_contact.4a9435e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/bg_contact.jpg
// module id = 272
// module chunks = 0